<template>
    <form action="" method="POST" @submit.prevent="submit" novalidate>
        <div class="form-toggle-wrapper">
            <form-input-type-toggle
                name="information_package"
                label="Bitte senden Sie mir ein Informationspaket mit Flyern für Patientinnen und Patienten zu"
                toggle-position="right"
            ></form-input-type-toggle>

            <!-- <form-input-type-toggle
                name="fax"
                label="Ich möchte Informationen per Fax erhalten"
                toggle-position="right"
            ></form-input-type-toggle> -->

            <!-- <div class="toggle-wrapper toggle-wrapper--with-border">
                <form-input-type-toggle
                    name="cme"
                    label="Ich möchte der CME-zertifizierten online Fortbildung teilnehmen"
                    toggle-position="right"
                ></form-input-type-toggle>

                <form-input-type-select
                    v-if="showCMEInput"
                    name="cme_datetime"
                    label="Innovation in der Diabetologie"
                    :options="[
                        {label: '13. Dezember 2022, 18:00 - 19:30', value: '2022-12-13 18:00'}
                    ]"
                    :errors="errors.cme_datetime"
                    required
                    full-border
                ></form-input-type-select>
            </div> -->

            <form-input-type-toggle
                name="test_account"
                label="Bitte erstellen Sie einen Vitadio Test-Account für mich"
                toggle-position="right"
            ></form-input-type-toggle>

            <!-- <form-input-type-toggle
                name="study"
                label="Ich möchte an einer Real-World Evidence-Studie teilnehmen"
                toggle-position="right"
            ></form-input-type-toggle> -->

            <!-- <form-input-type-toggle
                name="newsletter"
                label="Ich möchte den Vitadio-Newsletter abonnieren"
                toggle-position="right"
                with-border
            ></form-input-type-toggle> -->
        </div>

        <form-input-type-select
            name="specialization"
            label="Fachbereich"
            :options="[
                {label: 'Allgemeinmedizin'},
                {label: 'Innere Medizin'},
                {label: 'Psychosomatische Medizin und Psychotherapie'},
                {label: 'Diabetesberatung'},
                {label: 'Sonstiges'},
            ]"
            :errors="errors.specialization"
            required
            full-border
        ></form-input-type-select>

        <form-input-type-text
            v-if="showSpecializationInput"
            name="specialization_note"
            label="Fachbereich"
            :errors="errors.specialization_note"
            full-border
        ></form-input-type-text>

        <form-input-type-text
            name="title"
            label="Titel"
            :errors="errors.title"
            full-border
        ></form-input-type-text>

        <form-input-type-text
            name="name"
            label="Vorname"
            :errors="errors.name"
            full-border
            required
        ></form-input-type-text>

        <form-input-type-text
            name="surname"
            label="Nachname"
            :errors="errors.surname"
            full-border
            required
        ></form-input-type-text>

        <form-input-type-text
            name="institution"
            label="Praxisname / Firma"
            :errors="errors.institution"
            full-border
        ></form-input-type-text>

        <form-input-type-email
            name="email"
            label="E-Mail Adresse"
            :errors="errors.email"
            full-border
            required
        ></form-input-type-email>

        <form-input-type-phone-number
            name="phone"
            label="Telefonnummer"
            :errors="errors.phone"
            phoneCountry="de"
            full-border
        ></form-input-type-phone-number>

        <form-input-type-text
            v-if="showFaxInput"
            name="fax_number"
            label="Fax (erforderlich)"
            :errors="errors.fax_number"
            full-border
            required
        ></form-input-type-text>

        <form-input-type-text
            name="address"
            label="Straße und Hausnummer"
            :errors="errors.address"
            full-border
            :required="showPostAddressInput"
        ></form-input-type-text>

        <div class="col-2">
            <div class="col-item">
                <form-input-type-text
                    name="zip_code"
                    label="PLZ"
                    :errors="errors.zip_code"
                    full-border
                    required
                ></form-input-type-text>
            </div>

            <div class="col-item">
                <form-input-type-text
                    name="city"
                    label="Stadt"
                    :errors="errors.city"
                    full-border
                    :required="showPostAddressInput"
                ></form-input-type-text>
            </div>
        </div>

        <form-input-type-text-area
            name="text"
            label="Nachricht"
            :errors="errors.text"
            full-border
        ></form-input-type-text-area>

        <p class="new text-md">Mit dem Absenden des Formulars stimmen Sie der Verarbeitung Ihrer personenbezogenen Daten für die jeweils oben ausgewählten Dienste zu.<br>Weitere Informationen zu der Verarbeitung Ihrer Daten finden Sie in der <a href="/datenschutzerklarung" target="_blank">Datenschutzerklärung</a>.</p>

        <div class="form-toggle-wrapper">
            <form-input-type-toggle
                name="has_partner"
                label="Ich komme über einen der Vitadio-Partner"
                toggle-position="right"
            ></form-input-type-toggle>

            <form-input-type-select
                v-if="showVitadioPartnerInput"
                name="partner"
                label="Partner-Name"
                :options="[
                    {label: 'EvivaMed', value: 'EvivaMed'},
                    {label: 'Vitadio', value: 'Vitadio'},
                    {label: 'Digitale Patientenhilfe', value: 'Digitale Patientenhilfe'}
                ]"
                :errors="errors.partner"
                required
                full-border
            ></form-input-type-select>

            <p v-if="showVitadioPartnerInput" class="new-text-md">Durch die Angabe des Partnernamens erklären Sie sich mit der Weitergabe Ihrer Daten an den jeweiligen Partner zur weiteren Kontaktaufnahme einverstanden.</p>
        </div>

        <p class="form-mandatory-fields">* Felder mit Sternchen (*) sind Pflichtfelder.</p>

        <v-button label="Senden" type="submit" size="lg" full-width></v-button>

        <p class="after-form text-default text-centered">Nach dem Absenden Ihrer Anfrage erhalten Sie eine E-Mail mit allen wichtigen Informationen.</p>
    </form>
</template>

<script>
    export default {
        data() {
            return {
                errors: {},
                showPostAddressInput: false,
                showCMEInput: false,
                showVitadioPartnerInput: false,
                showFaxInput: false,
                ga_client_id: null,
                gcl_id: null,
                showSpecializationInput: false
            }
        },
        mounted() {
            var that = this
            const postAddressToggle = document.getElementById("information_package")
            const partnerToggle = document.getElementById("has_partner")
            const faxToggle = document.getElementById("fax")
            const specialization = document.getElementById("specialization")

            postAddressToggle.onchange = function(){
                if(postAddressToggle.checked) {
                    that.showPostAddressInput = true
                } else {
                    that.showPostAddressInput = false
                }
            }

            partnerToggle.onchange = function(){
                if(partnerToggle.checked) {
                    that.showVitadioPartnerInput = true
                } else {
                    that.showVitadioPartnerInput = false
                }
            }

            /* faxToggle.onchange = function(){
                if(faxToggle.checked) {
                    that.showFaxInput = true
                } else {
                    that.showFaxInput = false
                }
            } */

            specialization.onchange = function(){
                if(specialization.value === 'Sonstiges') {
                    that.showSpecializationInput = true
                } else {
                    that.showSpecializationInput = false
                }
            }
        },
        methods: {
            submit() {
                let formData = {}
                let that = this

                // serialize form data
                $(this.$el)
                    .serializeArray()
                    .forEach(({ name, value }) => {
                        formData[name] = value
                    })

                if(this.showSpecializationInput) {
                    formData['specialization'] = formData['specialization'] + ' - ' + formData['specialization_note']
                }

                formData['doctor_agreements'] = true

                let gaCookie = window.getCookie("_ga")
                let gclCookie = window.getCookie("_gcl_aw")

                if(gaCookie !== "" && gaCookie !== "undefined") {
                    this.ga_client_id = gaCookie
                }

                if((gclCookie !== "undefined" && gclCookie !== "") && this.ga_client_id === gaCookie) {
                    this.gcl_id = gclCookie
                }

                formData.ga_client_id = this.ga_client_id
                formData.gcl_id = this.gcl_id

                axios
                    .post('api/doctor-contact-form', formData, {
                        headers: {
                            'Accept-Language': 'de'
                        }
                    })
                    .then((e) => {
                        if(that.showVitadioPartnerInput) {
                            window.dataLayer.push({
                                'event': 'form_fachkreise',
                                'conversion': 'Fachkreise form',
                                'vitadio-partner': 'ano',
                                'partner-name': document.getElementById("partner").value
                            })
                        } else {
                            window.dataLayer.push({
                                'event': 'form_fachkreise',
                                'conversion': 'Fachkreise form',
                                'vitadio-partner': 'ne'
                            })
                        }

                        setTimeout(() => {
                            window.location.replace('fachkreise-success/'+e.data.form_id)
                        }, 250);
                    })
                    .catch((e) => {
                        console.log(e.response)
                        this.errors = e.response.data.errors
                        Vuemit.fire('Button--sending-failed', true)
                        this.scrollToError()
                    })
            },
            async scrollToError() {
                await this.$nextTick()

                var firstError = document.querySelector('.input-error-border')

                $('html, body').animate(
                    {
                        scrollTop: $(firstError).offset().top - 180
                    },
                    800
                )
            }
        }
    }
</script>
